import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

/**
 * One accordion row in the multi-line labor / equipment panel.
 *
 * Purely presentational: the container owns the FormGroup, the expanded state
 * and the delete confirmation. Equipment rows add the Rental toggle and Model;
 * everything else is the shared Basic field set.
 */
@Component({
  standalone: false,
  selector: 'app-labor-equipment-line-item',
  templateUrl: './labor-equipment-line-item.component.html',
  styleUrls: ['./labor-equipment-line-item.component.scss'],
})
export class LaborEquipmentLineItemComponent {
  @Input() entityType: 'labor' | 'equipment' = 'labor';
  @Input() lineItem: { id: string | number; type: string };
  @Input() form: FormGroup;
  @Input() isExpanded = false;
  @Input() subContractorOptions: any[] = [];
  @Input() typeOptions: any[] = [];
  @Input() errorMessages: { [control: string]: string } = {};
  /** False on a read-only report: hides the row menu (Delete). Field disabling is the container's job. */
  @Input() editable = true;

  @Output() toggleExpand = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<void>();
  @Output() checkForErrors = new EventEmitter<string>();
  /** A custom type entered in this row's type dropdown; the container adds it to the shared options. */
  @Output() typeAdded = new EventEmitter<{ value: any; label: string }>();

  constructor(private host: ElementRef<HTMLElement>) {
  }

  /** Bring this row to the top of the panel — the container calls it for a freshly added or opened row. */
  scrollIntoView() {
    this.host.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  get isEquipment(): boolean {
    return this.entityType === 'equipment';
  }

  /** Collapsed-row caption, e.g. "2 · 8 hrs". Empty until something is entered. */
  get summary(): string {
    const quantity = this.form?.controls['quantity']?.value;
    const hours = this.form?.controls['duration']?.value;
    const parts: string[] = [];
    if (quantity !== null && quantity !== undefined && quantity !== '') {
      parts.push(String(quantity));
    }
    if (hours !== null && hours !== undefined && hours !== '') {
      parts.push(`${hours} hrs`);
    }
    return parts.join(' · ');
  }

  onRentalToggle(event: MatSlideToggleChange) {
    this.form.controls['is_rental'].setValue(event.checked);
  }
}
